import { JSX, ReactNode } from 'react'

import { Container } from '../../components/container/container.js'
import {
    NotificationList,
    NotificationListProps,
} from '../../components/notification-list/notification-list.js'
import {
    TopNavigation,
    TopNavigationProps,
} from '../../components/top-navigation/top-navigation.js'
import { PageTitle, PageTitleProps } from '../../modules/page-title/page-title.js'

export interface ViewBaseProps {
    children?: ReactNode
    hero?: ReactNode
    notifications?: NotificationListProps
    navigation?: TopNavigationProps
    title?: PageTitleProps
}

export const ViewBase = (props: ViewBaseProps): JSX.Element => (
    <div className="view-base">
        {props.navigation && <TopNavigation {...props.navigation} />}
        {props.hero}
        <main className="view-base__main">
            <Container align="center">
                {props.title && <PageTitle {...props.title} />}
                {props.children}
            </Container>
        </main>
        {props.notifications && <NotificationList {...props.notifications} />}
    </div>
)
